import i18n from "@/i18n";

export const TipModalConfig = type => {
    return [
        {
            name: "namePlatform",
            label: i18n.t("zhiji.wiki.namePlatform"),
            type: "el-input",
            extendProps: {
                placeholder: i18n.t("zhiji.wiki.placeholder.tipPlatformName")
            }
        },
        {
            name: "name",
            label: i18n.t("zhiji.wiki.name"),
            type: "el-input",
            extendProps: {
                placeholder: i18n.t("zhiji.wiki.tipSdkName")
            }
        },
        {
            name: "nameStyle",
            label: i18n.t("zhiji.wiki.nameStyle"),
            type: "RadioGroup",
            extendProps: {
                items: [
                    {
                        label: i18n.t("zhiji.wiki.yellow"),
                        value: "#f7a502"
                    },
                    {
                        label: i18n.t("zhiji.wiki.gray"),
                        value: "#f0f0f0"
                    },
                    {
                        label: i18n.t("zhiji.wiki.blue"),
                        value: "#79cce2"
                    }
                ]
            }
        },
        {
            name: "icon",
            label: "Icon",
            type: "RadioGroup",
            extendProps: {
                items: [
                    {
                        label: "Hot",
                        value: "hot"
                    },
                    {
                        label: "New",
                        value: "new"
                    }
                ]
            }
        },
        {
            name: "title",
            label: i18n.t("zhiji.wiki.title"),
            type: type === "block" ? "el-input" : "ArrayInput",
            extendProps: {
                maxNum: 2,
                placeholder: i18n.t("zhiji.wiki.placeholder.tipTitle")
            }
        },
        {
            name: "baseViews",
            label: i18n.t("zhiji.materialLibrary.playNumber"),
            type: "el-input",
            extendProps: {
                placeholder: i18n.t("zhiji.materialLibrary.playNumberHolder")
            }
        },
        {
            name: "baseLikeNum",
            label: i18n.t("zhiji.materialLibrary.likeNumber"),
            type: "el-input",
            extendProps: {
                placeholder: i18n.t("zhiji.materialLibrary.likeNumberHolder")
            }
        },
        {
            name: "viewDate",
            label: i18n.t("zhiji.materialLibrary.showDate"),
            type: "el-date-picker",
            extendProps: {
                type: "date",
                format: "yyyy-MM-dd",
                "value-format": "yyyy-MM-dd"
            }
        },
        {
            name: "image",
            label: i18n.t("zhiji.wiki.tipImage"),
            type: "ImageCover",
            extendProps: {
                aspectRatio: 16 / 9
            }
        }
    ];
};

export const videoModalConfig = type => {
    return [
        {
            name: "namePlatform",
            label: i18n.t("zhiji.wiki.namePlatform"),
            type: "el-input",
            extendProps: {
                placeholder: i18n.t("zhiji.wiki.placeholder.videoPlatformName")
            }
        },
        {
            name: "name",
            label: i18n.t("zhiji.wiki.name"),
            type: "el-input",
            extendProps: {
                placeholder: i18n.t("zhiji.wiki.placeholder.videoPlatformName")
            }
        },
        {
            name: "nameStyle",
            label: i18n.t("zhiji.wiki.nameStyle"),
            type: "RadioGroup",
            extendProps: {
                items: [
                    {
                        label: i18n.t("zhiji.wiki.yellow"),
                        value: "#f7a502"
                    },
                    {
                        label: i18n.t("zhiji.wiki.gray"),
                        value: "#f0f0f0"
                    },
                    {
                        label: i18n.t("zhiji.wiki.blue"),
                        value: "#79cce2"
                    }
                ]
            }
        },
        {
            name: "icon",
            label: "Icon",
            type: "RadioGroup",
            extendProps: {
                items: [
                    {
                        label: "Hot",
                        value: "hot"
                    },
                    {
                        label: "New",
                        value: "new"
                    }
                ]
            }
        },
        {
            name: "videoDuration",
            label: i18n.t("zhiji.wiki.videoDuration"),
            type: "el-input",
            extendProps: {
                placeholder: i18n.t("zhiji.wiki.placeholder.videoDuration")
            }
        },
        {
            name: "title",
            label: i18n.t("zhiji.wiki.title"),
            type: type === "block" ? "el-input" : "ArrayInput",
            extendProps: {
                maxNum: 2,
                placeholder: i18n.t("zhiji.wiki.placeholder.videoTitle")
            }
        },
        {
            name: "baseViews",
            label: i18n.t("zhiji.materialLibrary.playNumber"),
            type: "el-input",
            extendProps: {
                placeholder: i18n.t("zhiji.materialLibrary.playNumberHolder")
            }
        },
        {
            name: "baseLikeNum",
            label: i18n.t("zhiji.materialLibrary.likeNumber"),
            type: "el-input",
            extendProps: {
                placeholder: i18n.t("zhiji.materialLibrary.likeNumberHolder")
            }
        },
        {
            name: "viewDate",
            label: i18n.t("zhiji.materialLibrary.showDate"),
            type: "el-date-picker",
            extendProps: {
                type: "date",
                format: "yyyy-MM-dd",
                "value-format": "yyyy-MM-dd"
            }
        },
        {
            name: "image",
            label: i18n.t("zhiji.wiki.videoImage"),
            type: "ImageCover",
            extendProps: {
                aspectRatio: 16 / 9
            }
        }
    ];
};
